import { FC } from 'react'
import ComponentTaxonomyGrid from '../packaging-components/components-grid'

const ComponentTaxonomy: FC = () => {
  return <ComponentTaxonomyGrid />
}

export default ComponentTaxonomy
